var map = {
	"./Global.png": 45180,
	"./Joy.png": 40739,
	"./Keno-01.png": 39047,
	"./Prime.png": 57182,
	"./Red and Blue.png": 98261,
	"./Red and White.png": 44825,
	"./Seven.png": 47646,
	"./Star.png": 33131,
	"./Viva.png": 879,
	"./jodanlogo-removebg-preview.png": 63508,
	"./logo.png": 66949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92715;